import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { kebabCase } from "lodash";
import { FocusEventHandler } from "react";

export type Value = string | number | Array<string>;
type Props = {
  options: Array<string | number>;
  value: Value;
  onChange: (value: SelectChangeEvent<string | number | string[]>) => void;
  label: string;
  id: string;
  error?: boolean;
  helperText?: string;
  multiple?: boolean;
  name?: string;
  onBlur?: FocusEventHandler;
  disabled?: boolean;
  suffix?: string;
};

function DropdownSelect({
  options,
  value,
  onChange,
  label,
  id,
  error,
  multiple,
  helperText,
  name,
  onBlur,
  disabled,
  suffix,
}: Props) {
  const inputLabel = `${kebabCase(label)}-dropdown-select-label`;
  const helperId = `${id}-helper-text`;
  const toDisplayValue = (value: Value) => `${value} ${suffix ? suffix : ""}`;

  return (
    <FormControl fullWidth variant="standard" error={error}>
      <InputLabel disabled={disabled} id={inputLabel}>
        {label}
      </InputLabel>
      <Select
        labelId={inputLabel}
        data-testid={id}
        id={id}
        name={name ?? id}
        value={value}
        onBlur={onBlur}
        onChange={(value) => onChange(value)}
        label={label}
        multiple={multiple}
        displayEmpty
        disabled={disabled}
        inputProps={{ "aria-describedby": helperId }}
      >
        {options.map((o) => {
          return (
            <MenuItem data-testid={o} key={o} value={o}>
              {toDisplayValue(o)}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{helperText || ""}</FormHelperText>
    </FormControl>
  );
}

export default DropdownSelect;
